import { Select, Tooltip } from "antd"
import { useGetTaxCodesQuery } from "../../../../domain/invoicing/invoicingQueries"

type Props = {
  selectedSalesTaxId?: number | null
  canEditGroupFields: boolean
  onChange: (value: number | null | undefined) => void
}

const QboSalesTaxSelector = ({selectedSalesTaxId, canEditGroupFields, onChange}: Props) => {
  const getTaxCodesQuery = useGetTaxCodesQuery(true)
  const taxCodes = getTaxCodesQuery.data ?? []

  const disabled = !canEditGroupFields

  const select = <Select
    value={selectedSalesTaxId}
    options={taxCodes?.map(x => ({ label: x.name, value: parseInt(x.id) })) ?? []}
    onChange={(value) => onChange(value)}
    popupMatchSelectWidth={false}
    disabled={disabled}
  />

  return disabled
    ? <Tooltip title="This can only be changed at the group level.">{select}</Tooltip>
    : select
}

export default QboSalesTaxSelector